module.exports = __webpack_public_path__ + "static/media/01_Special_Ep3_The_Waste_Chain.3d0a4cf1.jpg";